import { css } from '@emotion/react';
import { Theme } from '@mui/material';

export const styles = {
  container: (theme: Theme, isSaving: boolean , online: boolean, hasChanges: boolean) => css`
    position: absolute;
    top: 10px;
    right: 10px;
    height: 30px;
    padding: ${theme.spacing(0.5)} ${theme.spacing(1)};
    font-size: 12px;
    color: ${!online ? '#FFC107' : isSaving ? '#8c8526' : hasChanges ? '#2196F3' : '#618761'};
    border: 1px solid ${!online  ? '#FFC107' : isSaving ? '#8c8526' : hasChanges ? '#2196F3' : '#618761'};
    border-radius: ${theme.spacing(0.5)};
    display: flex;
    align-items: center;
    line-height: normal;
  `,
  textContainer: css`
    min-width: 35px;
    
  `,
  iconContainer: css`
    margin-left: 10px;
    width: 20px;
  `,
  checkIcon: css`
    
    font-size: 18px;
    color: #618761;
  `,
  emptyContainer: css`
    width: 70px;
    margin-right: 4px;
  `
};
